/**
 * @brief 洋鼹鼠平台合作，当从洋鼹鼠app进入行程大师页面时，
 *  会修改title显示洋鼹鼠，以及头部出现导航条
 *
 */
(function(){
  if(document.cookie.indexOf("_sr=gp_4235293256") != -1){
    document.title = '洋鼹鼠-海外旅游';
    var html = '<div class="layout-auto yangyanshu-head" style="font-size:0;line-height:0"><a href="http://www.iyanshu.cn/mobile/"><img src="https://f7.jiejiatech.net/y17/0406/1752/00cqh_o.png" width="100%"></a></div>';
    $(".js-sys-menu-wrap").prepend(html);
    
    //在A计划页，以上添加dom的办法会失效，怀疑和angluar有关
    //所以在domready后再检查一次
    $(function(){
      if(!$(".yangyanshu-head").length){
        $(".js-sys-menu-wrap").prepend(html);
      }
    });
  }
})();




// WEBPACK FOOTER //
// ./src/module/yangyanshu-head.js